import type { ApiClient } from "../api-client";
import type { RatingItemType, RatingResponse } from "../types/ratings";

export function getRating(
  client: ApiClient,
  itemType: RatingItemType,
  itemId: string,
): Promise<RatingResponse> {
  return client.get(`/ratings/${itemType}/${itemId}`);
}

/** Set (or change) the caller's 1-5 rating. 403 when the item is not collected. */
export function rateItem(
  client: ApiClient,
  itemType: RatingItemType,
  itemId: string,
  rating: number,
): Promise<RatingResponse> {
  return client.post(`/ratings/${itemType}/${itemId}`, { rating });
}

/** Remove the caller's rating. */
export function clearRating(
  client: ApiClient,
  itemType: RatingItemType,
  itemId: string,
): Promise<RatingResponse> {
  return client.delete(`/ratings/${itemType}/${itemId}`);
}
